import { render } from "./CourseCreatePage.vue?vue&type=template&id=702a2e3a&scoped=true"
import script from "./CourseCreatePage.vue?vue&type=script&lang=js"
export * from "./CourseCreatePage.vue?vue&type=script&lang=js"

import "./CourseCreatePage.vue?vue&type=style&index=0&id=702a2e3a&lang=css"
import "./CourseCreatePage.vue?vue&type=style&index=1&id=702a2e3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-702a2e3a"]])

export default __exports__